// extracted by mini-css-extract-plugin
export default {"menuActions":"ActiveRecordTab_menuActions__ZStl0","statusContent":"ActiveRecordTab_statusContent__JsBEH"};